import React, { Fragment } from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  const benefits = [<Fragment data-id="element-310">
      Bajar grasa <strong data-id="element-311">sin pasar hambre.</strong>
    </Fragment>, <Fragment data-id="element-312">
      Reducir la panza con un <strong data-id="element-313">déficit calórico inteligente.</strong>
    </Fragment>, <Fragment data-id="element-314">
      <strong data-id="element-315">Mantener músculo</strong> para verte más firme.
    </Fragment>, <Fragment data-id="element-316">
      Organizar tus comidas <strong data-id="element-317">sin complicarte.</strong>
    </Fragment>, <Fragment data-id="element-318">
      Medir tu progreso <strong data-id="element-319">sin obsesionarte</strong> con la balanza.
    </Fragment>, <Fragment data-id="element-320">
      <strong data-id="element-321">Sostener el proceso</strong> durante 12 semanas.
    </Fragment>];
  return <section className="py-14 md:py-20 bg-zinc-900 pt-[10px] pb-[10px]" data-id="element-322">
      <div className="container mx-auto px-5 sm:px-6 md:px-8" data-id="element-323">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto" data-id="element-324">
          <div className="text-center mt-[0px] mb-[0px]" data-id="element-325">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-display text-white mb-8 uppercase tracking-tight leading-[0.95]" data-id="element-326">
              Por eso creamos <br className="hidden md:block" data-id="element-327" />
              <span className="text-green-500" data-id="element-328">Plan Anti Panza</span>
            </h2>

            <p className="text-xl md:text-2xl text-zinc-300 leading-relaxed max-w-3xl mx-auto mb-12" data-id="element-329">
              Un ebook digital diseñado para ayudarte a bajar grasa, reducir la
              panza y recuperar confianza con un{' '}
              <strong className="text-white" data-id="element-330">
                método simple de 12 semanas.
              </strong>
            </p>

            <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-6 text-lg font-bold text-white mb-12" data-id="element-331">
              <span className="bg-zinc-800/80 border border-zinc-700 px-6 py-4 rounded-xl shadow-lg" data-id="element-332">
                ❌ No es una dieta extrema.
              </span>
              <span className="bg-zinc-800/80 border border-zinc-700 px-6 py-4 rounded-xl shadow-lg" data-id="element-333">
                ❌ No es un plan imposible.
              </span>
              <span className="bg-zinc-800/80 border border-zinc-700 px-6 py-4 rounded-xl shadow-lg" data-id="element-334">
                ❌ No es vivir contando calorías.
              </span>
            </div>

            <p className="text-xl text-zinc-300 leading-relaxed max-w-3xl mx-auto" data-id="element-335">
              Es una{' '}
              <strong className="text-white border-b-2 border-green-500" data-id="element-336">
                hoja de ruta clara
              </strong>{' '}
              para aprender a comer mejor, moverte más, entrenar inteligente y
              construir hábitos que puedas sostener.
            </p>
          </div>

          <div className="bg-gradient-to-br from-green-900/30 to-green-950/30 border border-green-800/50 rounded-3xl p-8 md:p-16 shadow-2xl pt-[15px] pb-[15px]" data-id="element-337">
            <h3 className="text-3xl md:text-4xl font-display text-white uppercase tracking-tight text-center mt-[15px] mb-[15px]" data-id="element-338">
              Este sistema te ayuda a:
            </h3>

            <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-339">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: 0.05 * index
            }} className="flex items-start gap-4 bg-black/20 p-6 rounded-2xl pt-[10px] pb-[10px]" data-id="element-340">
                  <CheckCircleIcon className="w-8 h-8 text-green-500 flex-shrink-0" data-id="element-341" />
                  <p className="text-white text-lg leading-relaxed" data-id="element-342">
                    {benefit}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}